<p class="chatList-title">
  {{ 'commons:chat.new-conversation' | translate }}
</p>
<ng-container *ngIf="!roomid; then radioSelection; else checkboxSelection"></ng-container>

<!-- RADIO SELECTION TEMPLATE -->
<ng-template #radioSelection>
  <mat-radio-group aria-labelledby="" class="chatList-content" [(ngModel)]="selectedGuest">
    <div class="chatList-item" *ngFor="let item of availableGuests" [ngClass]="!item.isPresent || item.isOngoing ? 'disabled-item' : ''">
      <mat-radio-button [disabled]="!item.isPresent || item.isOngoing" [value]="item">
        <p>{{ item.firstName | capitalize }} {{ item.lastName | uppercase }}</p>
        <div class="status">
          <span
            class="status-indicator"
            aria-hidden="true"
            [ngClass]="item.isOngoing ? 'ongoing' : item.isPresent ? 'available' : 'unavailable'"
          >
          </span>
          <!-- TODO ADD DEDICATED COMPONENT -->
          <span class="status" [ngClass]="item.isOngoing ? 'ongoing' : item.isPresent ? 'available' : 'unavailable'"></span>
          <div class="status-text" *ngIf="item.isPresent && !item.isOngoing">
            {{ 'agent:panel.chat.status_available' | translate }}
          </div>
          <div class="status-text" *ngIf="!item.isPresent && !item.isOngoing">
            {{ 'agent:panel.chat.status_unavailable' | translate }}
          </div>
          <div class="status-text" *ngIf="item.isOngoing">
            {{ 'agent:panel.chat.status_ongoing' | translate }}
          </div>
        </div>
      </mat-radio-button>
    </div>
  </mat-radio-group>
</ng-template>

<!-- CHECKBOX SELECTION TEMPLATE -->
<ng-template #checkboxSelection>
  <div class="chatList-content">
    <div class="chatList-item" *ngFor="let item of availableGuests" [ngClass]="!item.isPresent || item.isOngoing ? 'disabled-item' : ''">
      <mat-checkbox (click)="updateSelectedList(item)" [value]="item" [disabled]="!item.isPresent || item.isOngoing">
        <p>{{ item.firstName | capitalize }} {{ item.lastName | uppercase }}</p>
        <div class="status">
          <span
            class="status-indicator"
            aria-hidden="true"
            [ngClass]="item.isOngoing ? 'ongoing' : item.isPresent ? 'available' : 'unavailable'"
          >
          </span>
          <!-- TODO ADD DEDICATED COMPONENT -->
          <span class="status" [ngClass]="item.isOngoing ? 'ongoing' : item.isPresent ? 'available' : 'unavailable'"></span>
          <div class="status-text" *ngIf="item.isPresent && !item.isOngoing">
            {{ 'agent:panel.chat.status_available' | translate }}
          </div>
          <div class="status-text" *ngIf="!item.isPresent && !item.isOngoing">
            {{ 'agent:panel.chat.status_unavailable' | translate }}
          </div>
          <div class="status-text" *ngIf="item.isOngoing">
            {{ 'agent:panel.chat.status_ongoing' | translate }}
          </div>
        </div>
      </mat-checkbox>
    </div>
  </div>
</ng-template>
<div class="chatList-action-buttons">
  <div title="{{ 'commons:chat.new_chat' | translate }}">
    <button
      mat-icon-button
      class="actionIcon cng-ico_check"
      [ngClass]="!(selected || selectedGuests.length > 0) ? 'disabled-button' : ''"
      [disabled]="!(selected || selectedGuests.length > 0)"
      (click)="addNewRoom()"
    ></button>
  </div>
  <div title="{{ 'commons:chat.cancel' | translate }}">
    <button mat-icon-button class="actionIcon cng-ico_annuler" (click)="closeList()"></button>
  </div>
</div>
